<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 隐藏body和html的滚动条 */
html, body {
  overflow: hidden;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  overflow: hidden;
}

/* 隐藏所有滚动条，但保持滚动功能 */
::-webkit-scrollbar {
  display: none;
}

/* Firefox滚动条隐藏 */
* {
  scrollbar-width: none;
}

/* IE滚动条隐藏 */
* {
  -ms-overflow-style: none;
}
</style>
